import Profile from './Profile.vue'

export default Profile



// WEBPACK FOOTER //
// ./client/components/Profile/index.js